import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';
import { Dayjs } from 'dayjs';
import * as timezone from 'dayjs/plugin/timezone';
import * as isBetween from 'dayjs/plugin/isBetween';
import * as isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(duration);
dayjs.locale('es');

export const roDate = dayjs;

export const TIME_FORMAT_24H = 'HH:mm [hrs]';
export const TIME_FORMAT_12H = 'hh:mm A';
export const TIME_FORMAT_24H_WITH_SECONDS = 'HH:mm:ss';
export const TIME_FORMAT_12H_WITH_SECONDS = 'hh:mm:ss A';
export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_TIME_FORMAT_12H = 'DD-MM-YYYY hh:mm a';
export const DATE_TIME_FORMAT_24H = 'DD-MM-YYYY hh:mm [hrs]';
export const DATE_FRIENDLY = 'D [de] MMMM YYYY';
export const DATE_LONG_FORMAT = 'D MMMM, YYYY';

export const getPeruTime = (): Dayjs => {
    return roDate().tz('America/Lima');
};

export function formatRemainingTime(targetDate: string | dayjs.Dayjs): string {
    const now = getPeruTime();
    const target = typeof targetDate === 'string' ? dayjs(targetDate) : targetDate;
    const diff = target.diff(now);
    const durationObj = dayjs.duration(diff);

    const days = durationObj.days();
    const hours = durationObj.hours();
    const minutes = durationObj.minutes();

    const parts: string[] = [];

    if (diff <= 0) {
        return ''; // Retorna una cadena vacía si el tiempo ha expirado
    }

    if (days > 0) {
        parts.push(`${days} dia${days > 1 ? 's' : ''}`);
    }

    if (hours > 0) {
        parts.push(`${pad(hours)} hora${hours > 1 ? 's' : ''}`);
    } else if (days > 0 && minutes > 0) {
        parts.push(`00 hora${hours > 1 ? 's' : ''}`); // Mostrar "00 horas" solo si hay días y minutos
    }

    if (minutes >= 0) {
        parts.push(`${pad(minutes)} minuto${minutes > 1 ? 's' : ''}`);
    } else if ((days > 0 || hours > 0) && parts.length === 0) {
        parts.push(`00 minuto${minutes > 1 ? 's' : ''}`); // Mostrar "00 minutos" si hay días u horas y no se han mostrado minutos
    }

    return parts.join(', ');
}
function pad(num: number): string {
    return num < 10 ? '0' + num : '' + num;
}

export const dateTransform = (
    date: string | Date,
    formatType: 'time' | 'date' | 'friendly' | 'relative' | 'date-time' | 'long-date' | 'remaining' | string = 'date',
    fromUTC: boolean = false
): string => {
    if (!date) {
        return ' - ';
    }

    const dateObject = fromUTC ? dayjs.utc(date) : dayjs(date);

    switch (formatType) {
        case 'date':
            return (dateObject as Dayjs).format(DATE_FORMAT);
        case 'time':
            return (dateObject as Dayjs).format(TIME_FORMAT_12H);
        case 'date-time':
            return (dateObject as Dayjs).format(DATE_TIME_FORMAT_12H);
        case 'friendly':
            return (dateObject as Dayjs).format(DATE_FRIENDLY);
        case 'long-date':
            return (dateObject as Dayjs).format(DATE_LONG_FORMAT);
        case 'relative':
            return (dateObject as Dayjs).from(getPeruTime());
        case 'remaining':
            return formatRemainingTime(dateObject as Dayjs);
        default:
            return (dateObject as Dayjs).format(formatType);
    }
};
